import React from 'react';

import type { Bordereau, ModeReglementsPointageType } from '@/types';

export type BordereauRemiseContextType = {
  total: number;
  bordereaux: Bordereau[];
  sorts: Record<string, 'asc' | 'desc'>;
  loading: boolean;

  setBordereaux: React.Dispatch<React.SetStateAction<Bordereau[]>>;
  setSorts: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  setTotal: React.Dispatch<React.SetStateAction<number>>;
  reset: () => void;
};

// Registry pour stocker tous les contextes créés dynamiquement
export const BordereauRemiseContextRegistry = new Map<
  ModeReglementsPointageType,
  React.Context<BordereauRemiseContextType | null>
>();

// Fonction pour obtenir ou créer un contexte pour un code donné
export const getBordereauRemiseContext = (code: ModeReglementsPointageType) => {
  if (!BordereauRemiseContextRegistry.has(code)) {
    const newContext = React.createContext<BordereauRemiseContextType | null>(null);
    BordereauRemiseContextRegistry.set(code, newContext);
  }
  return BordereauRemiseContextRegistry.get(code)!;
};

// Pour la compatibilité, on exporte un contexte par défaut (non utilisé)
const BordereauRemiseContext = React.createContext<
  Map<ModeReglementsPointageType, BordereauRemiseContextType>
>(new Map());

export default BordereauRemiseContext;
